import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=5b01d36b&scoped=true&"
import script from "./VideoCarousel.vue?vue&type=script&lang=js&"
export * from "./VideoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VideoCarousel.vue?vue&type=style&index=0&id=5b01d36b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01d36b",
  null
  
)

export default component.exports